export default __webpack_public_path__ + "fonts/inter-latin-400-normal.c96fe5ff771f9e7b53ab.woff2";